import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.instrument-gallery-swiper', {
        modules: [Navigation],
        slidesPerView: 'auto',
        centeredSlides: false,
        spaceBetween: 16,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        loop: false,
        allowTouchMove: false,
        grabCursor: false,
    });

    // Modal functionality
    const galleryImages = document.querySelectorAll('.gallery-image');
    const modalImage = document.getElementById('modalImage');

    galleryImages.forEach(image => {
        image.addEventListener('click', function () {
            const fullImageUrl = image.getAttribute('data-bs-image');
            modalImage.src = fullImageUrl;
        });
    });
});
